.row-divider {
  margin: 12px 0 !important;
}

.typography {
  margin-bottom: 0 !important;
}
